module.exports = __webpack_public_path__ + "static/media/mifacturaperublanco.f66bfff8.png";